/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
function updateHeaderNav(limit) {
    var more = document.querySelector('.nav-dropdown-more');
    var navItems = document.querySelectorAll('.nav-bar__linklist .nav-bar__item:not(.nav-bar__item-more)');

    while (more.firstChild) {
        more.removeChild(more.lastChild);
    }

    for (var i = 0; i < navItems.length; i++) {
        if (i < limit) {
            console.log('removing hidden...', i);
            navItems[i].classList.remove('hidden');
            continue;
        }

        var newListItem = document.createElement('li');
        var newLinkItem = document.createElement('a');
        newListItem.setAttribute('class', 'nav-dropdown__item');
        newLinkItem.setAttribute('class', 'nav-dropdown__link link');
        newLinkItem.setAttribute('data-type', 'menuitem');

        var targetLink = navItems[i].querySelector('.nav-bar__link');
        navItems[i].classList.add('hidden');

        newLinkItem.textContent = targetLink.textContent;
        newLinkItem.setAttribute('href', targetLink.getAttribute('href'));
        newListItem.appendChild(newLinkItem);
        more.appendChild(newListItem);
    }
}


function adjustQuickLinksMenu() {
    var active = document.querySelector('.collection__filter-linklist.level-2 > li > .is-active');
    if (active) {
        var others = active.parentNode.parentNode.querySelectorAll('.collection__filter-linklist.level-2 > li > a:not(.is-active):not(.view-all)');
        for (var i = 0; i < others.length; i++) {
            others[i].parentNode.classList.add('hidden');
        }
    }

    var active2 = document.querySelector('.collection__filter-linklist.level-1 > .has-active-links');
    if (active2) {
        var others2 = document.querySelectorAll('.collection__filter-linklist.level-1 > li:not(.has-active-links)');
        for (var j = 0; j < others2.length; j++) {
            others2[j].classList.add('hidden');
        }
    }
}

document.addEventListener('DOMContentLoaded', adjustQuickLinksMenu);

document.getElementById('PaymentPlanItemAfterPay').addEventListener('click', function() {
    console.log('clicked afterpay')
    // Get the other element by its id
    let element = document.getElementById('PaymentPlanModalAfterPay');
    console.log(element)

    // Add 'visible' class or modify style directly
    element.setAttribute('visible', 'true');
});

document.getElementById('PaymentPlanItemZip').addEventListener('click', function() {
    // Get the other element by its id
    let element = document.getElementById('PaymentPlanModalZip');

    // Add 'visible' class or modify style directly
    element.classList.remove('hidden');
});

document.getElementById('zip-widget-close-button').addEventListener('click', function() {
    console.log('clicked zip')
    // Get the other element by its id
    let element = document.getElementById('PaymentPlanModalZip');

    // Add 'visible' class or modify style directly
    element.classList.add('hidden');
});


